<template>
  <a-modal
    :title="$t('title.itemPackMaintain')"
    :centered="true"
    :visible="visible"
    width="65%"
    :destroyOnClose="destroyOnClose"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-descriptions :column="3" bordered style="margin-top: -24px;margin-bottom: -15px">
        <a-descriptions-item :label="$t('business.label.itemNo')">
          <span>{{item.no}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.itemName')">
          <span>{{item.name}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.storer')">
          <span>{{storer.name}}</span>
        </a-descriptions-item>

        <a-descriptions-item :label="$t('business.label.specification')">
          <span>{{pack.specification}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.factor')">
          <span>{{pack.factor}}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.uom')">
          <span>{{pack.uom}}</span>
        </a-descriptions-item>

        <a-descriptions-item :label="$t('business.label.length')">
          <a-input-number v-model="pack.dimension.length" :min="1" style="width: 100%"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.width')">
          <a-input-number v-model="pack.dimension.width" :min="1" style="width: 100%"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.height')">
          <a-input-number v-model="pack.dimension.height" :min="1" style="width: 100%"/>
        </a-descriptions-item>

        <a-descriptions-item :label="$t('business.label.visualized')">
          <a-checkbox v-model="item.visualized"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.scattered')">
          <a-checkbox v-model="item.scattered"/>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.locationLimit')">
          <a-input-search style="width: 100%"
                          v-model="locationLimits"
                          readOnly
                          @search="limitMaintain"
                          @dblclick="limitMaintain"/>
        </a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-modal>
</template>
<script>
import { findOne, save } from '@/api/Api'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'
import { Storer } from '@/api/dto/common/Storer'
import { getStrings } from '@/utils/util'

export default {
  name: 'ReceiptMaintainModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      destroyOnClose: true,
      item: new Item(),
      pack: new Pack(),
      storer: new Storer(),
      locationLimits: null,
      loading: false
    }
  },
  methods: {
    open(detail) {
      if (detail) {
        this.storer = Object.assign(new Storer(), detail.storer)
        this.item = Object.assign(new Item(), detail.item)
        this.locationLimits = getStrings(detail.locationLimits, 'name')
        this.visible = true
        if (detail.pack.id) {
          this.loading = true
          findOne('packFactory', { id: detail.pack.id }).then(res => {
            if (res.success) {
              this.pack = new Pack(res.result)
            } else {
              this.confirmLoading = false
            }
          }).finally(() => {
            this.loading = false
          })
        }
      }
    },
    handleOk() {
      this.confirmLoading = true
      save('packPersister', this.pack).then(res => {
        if (res.success) {
          this.pack = new Pack(res.result)
          this.$emit('success', this.pack)
          let that = this
          this.$success({
            title: '保存成功',
            content: '将返回收货界面',
            onOk() {
              that.handleCancel()
            },
            okText: '确定',
            centered: true
          })
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    handleCancel() {
      this.visible = false
    },
    limitMaintain() {
      let itemData = Object.assign({}, this.item)
      itemData.storer = this.storer
      this.$route.params.item = itemData
      this.$router.push(
        {
          name: 'LocationForItemBase'
        })
      this.handleCancel()
    }
  }
}
</script>